/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ONLINE / OFFLINE for monitored chargers; UNKNOWN when the platform cannot measure right now; null when the asset is not monitored.
 * @export
 */
export const ConnectivityStatus = {
    Online: 'ONLINE',
    Offline: 'OFFLINE',
    Unknown: 'UNKNOWN'
} as const;
export type ConnectivityStatus = typeof ConnectivityStatus[keyof typeof ConnectivityStatus];


export function instanceOfConnectivityStatus(value: any): boolean {
    for (const key in ConnectivityStatus) {
        if (Object.prototype.hasOwnProperty.call(ConnectivityStatus, key)) {
            if (ConnectivityStatus[key as keyof typeof ConnectivityStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ConnectivityStatusFromJSON(json: any): ConnectivityStatus {
    return ConnectivityStatusFromJSONTyped(json, false);
}

export function ConnectivityStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectivityStatus {
    return json as ConnectivityStatus;
}

export function ConnectivityStatusToJSON(value?: ConnectivityStatus | null): any {
    return value as any;
}

export function ConnectivityStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ConnectivityStatus {
    return value as ConnectivityStatus;
}

